module.exports = __webpack_public_path__ + "img/banner5.7c218b16.jpg";